<template>
	<div class="event-comment-list--modal">
		<form @submit.prevent="searching">
			<ManagingSection class="search-by-enter__container">
				<ManagingBox title="닉네임">
					<input
						class="search-by-enter__target"
						type="text"
						:value="nickName"
						@input="singleCommit('nickName', $event.target.value)"
					/>
				</ManagingBox>
				<ManagingBox title="작성일시">
					<DateRange
						:value="{
							from: createDateRange[0],
							to: createDateRange[1],
						}"
						type="date"
						@input="createdDateRangeChange"
					/>
				</ManagingBox>
				<ManagingBox title="내용">
					<input
						class="search-by-enter__target"
						type="text"
						:value="eventReply"
						@input="singleCommit('eventReply', $event.target.value)"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button class="btn-main blue bordered" @click="initFilter">
					검색조건 초기화
				</button>
			</div>
		</form>
		<hr class="section__divider" />
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left" v-if="totalData">
					검색결과 : 전체 {{ totalData.replyTotal }}건 / 노출
					{{ totalData.replyTotal_display }}건 / 비노출
					{{ totalData.replyTotal_nonDisplay }}건
				</div>
				<div class="section__info__right">
					<SelectBox
						addClass="form-m section__info__items"
						idKey="value"
						valueKey="name"
						:options="orderList"
						:val="order"
						@changing="changeImmediately('order', $event)"
					/>
					<SelectBox
						addClass="form-m section__info__items"
						idKey="value"
						valueKey="name"
						:options="limitList"
						:val="limit"
						@changing="changeImmediately('limit', $event)"
					/>
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main event-comment-list__comment-list-table">
				<thead>
					<tr>
						<th>등록일시</th>
						<th>회원번호</th>
						<th>닉네임</th>
						<th>내용</th>
						<th>노출상태</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody v-if="parsedCommentList">
					<tr
						v-for="commentItem in parsedCommentList"
						:key="`commentItem${commentItem.createdDate}${commentItem.idEvent}${commentItem.idRegister}`"
					>
						<td>{{ commentItem.createdDate }}</td>
						<td>{{ commentItem.idRegister }}</td>
						<td>
							<a
								class="event-comment-list__table__item-link"
								:href="`/register/register-info/${commentItem.idRegister}`"
								target="_blank"
								>{{ commentItem.nickName }}</a
							>
						</td>
						<td
							class="event-comment-list__comment-list-table__cell-content"
						>
							{{ commentItem.eventReply }}
						</td>
						<td
							class="event-comment-list__comment-list-table__cell-display-status"
						>
							<button
								class="btn"
								type="button"
								@click="
									toggleDisplay(
										commentItem.idEvent,
										commentItem.idEventReply,
										commentItem.isDisplay,
										commentItem.isDisplayMsg
									)
								"
							>
								{{ commentItem.isDisplayMsg }}
							</button>
						</td>
						<td>
							<button
								class="btn-delete"
								type="button"
								@click="
									deleting(
										commentItem.idEvent,
										commentItem.idEventReply
									)
								"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				v-if="totalData"
				:totalItem="totalData.replyTotal"
				:limit="limit"
				:offset="offset"
				:pageLengPerOne="10"
				@to="paging"
				slot="pagination"
			/>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				class="btn-main blue bordered"
				type="button"
				@click="closing"
			>
				닫기
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';
	import SelectBox from '@/components/SelectBox.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'EventCommentList',
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			SelectBox,
			PaginationBox,
			SearchByEnter,
		},
		extends: SearchByEnter,
		computed: {
			...mapState('EventCommentList', [
				'nickName',
				'eventReply',
				'orderList',
				'order',
				'limitList',
				'limit',
				'offset',
				'totalData',
				'createDateRange',
			]),
			...mapGetters('EventCommentList', ['parsedCommentList']),
		},
		methods: {
			singleCommit(key, value) {
				this.$store.commit('EventCommentList/commit', [{ key, value }]);
			},
			changeImmediately(key, value) {
				this.$store.dispatch('EventCommentList/changeImmediately', {
					key,
					value,
				});
			},
			toggleDisplay(idEvent, idEventReply, isDisplay, msg) {
				if (confirm(`해당 댓글을 ${msg}하시겠습니까?`)) {
					this.$store.dispatch('EventCommentList/toggleDisplay', {
						idEvent,
						idEventReply,
						isDisplay: !isDisplay,
					});
				}
			},
			deleting(idEvent, idEventReply) {
				if (confirm(`해당 댓글을 정말 삭제하시겠습니까?`)) {
					this.$store.dispatch('EventCommentList/deleting', {
						idEvent,
						idEventReply,
					});
				}
			},
			searching() {
				this.singleCommit('offset', 0);
				this.$store.dispatch('EventCommentList/getCommentList');
			},
			initFilter() {
				this.$store.commit('EventCommentList/initFilter');
			},
			paging(offset) {
				this.$store.dispatch('EventCommentList/offset', offset.offset);
			},
			closing() {
				this.$emit('close');
			},
			createdDateRangeChange({ from, to }) {
				this.singleCommit('createDateRange', [from, to]);
			},
			excelDown() {
				this.$store.dispatch('EventCommentList/excelDown');
			},
		},
		created() {
			this.$store.dispatch('EventCommentList/getCommentList');
		},
	};
</script>

<style lang="scss" scoped>
	.event-comment-list--modal {
		.event-comment-list__comment-list-table {
			th,
			td {
				white-space: nowrap;
			}

			.event-comment-list__comment-list-table__cell-content {
				white-space: normal;
			}

			.event-comment-list__comment-list-table__cell-display-status {
				.btn {
					margin: 0 auto;
				}
			}
		}

		.event-comment-list__table__item-link {
			color: $font-blue;
			font-weight: 700;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
